<template>
    <div class="index-page">
        <div class="page-left">
            <at-menu-icon class="menu-icon"></at-menu-icon>
        </div>
        <div class="page-right" @click="toggleMenu(true)">
            
            <div class="title">
                <img src="/assets/images/index/title1.png">
            </div>
            
            <div class="card-row">
                
                <div class="card-one">
                    
                    <div class="card-icon">
                        <img src="/assets/images/index/icon-10.png">
                    </div>
                    
                    <div class="icon">
                        <img src="/assets/images/index/icon1.png">
                    </div>
                    
                    <div class="icon2">
                        <img src="/assets/images/index/icon-8.png">
                    </div>
                    
                    <div class="label">今日新增客资</div>
                    <div class="number">
                        <span>{{ detail.reserved_leads.today_new_lead }}</span>
                        <div class="line"></div>
                    </div>
                    <div class="total">
                        <span>累计收集客资</span>
                        <span>{{ detail.reserved_leads.total_leads }}</span>
                    </div>
                </div>
                
                <div class="card-two">
                    <div class="card card1">
                        <div class="icon">
                            <img src="/assets/images/index/icon-2.png">
                        </div>
                        
                        <div class="label">今日新增用户</div>
                        <div class="number">{{ detail.initial_traffic.today_new_user }}</div>
                        <div class="total">
                            <span>累计用户总数</span>
                            <span>{{ detail.initial_traffic.total_users }}</span>
                        </div>
                    </div>
                    <div class="card card2">
                        <div class="icon">
                            <img src="/assets/images/index/icon-3.png">
                        </div>
                        
                        <div class="label">
                            <span>今日收款金额</span>
                            <span>(元)</span>
                        </div>
                        
                        <div class="number">{{ detail.order.today_revenue }}</div>
                        <div class="total">
                            <span>累计收款金额</span>
                            <span>{{ detail.order.total_revenue }}</span>
                        </div>
                    
                    </div>
                    <div class="card card3">
                        <div class="icon">
                            <img src="/assets/images/index/icon-4.png">
                        </div>
                        
                        <div class="label">
                            <span>今日对外分佣金额</span>
                            <span>(元)</span>
                        </div>
                        
                        <div class="number">{{ detail.order.today_commission }}</div>
                        <div class="total">
                            <span>累计对外分佣金额</span>
                            <span>{{ detail.order.total_commission }}</span>
                        </div>
                    </div>
                    <div class="card card4">
                        <div class="icon">
                            <img src="/assets/images/index/icon-5.png">
                        </div>
                        
                        <div class="label">新增待服务记录</div>
                        <div class="number">{{ detail.service_record.today_new_service_record }}</div>
                        <div class="total">
                            <span>累计处理服务记录</span>
                            <span>{{ detail.service_record.total_service_record }}</span>
                        </div>
                    </div>
                </div>
            
            </div>
            
            <div class="model-box">
                <div class="model-content">
                    <div class="title">
                        <img src="/assets/images/index/title2.png">
                    </div>
                    
                    <div class="model">
                        <div class="icon">
                            <img src="/assets/images/index/icon-9.png">
                        </div>
                        
                        <div class="model-left">
                            <div class="add-num">
                                <span>新增成交</span>
                                <span>｜</span>
                                <span>{{ detail.deal_metrics.leads_converted }}</span>
                                <span>个</span>
                            </div>
                            <div class="trapezoid-box">
                                <img src="/assets/images/index/charts-bg1.png">
                                <div class="num">{{
                                        getPercent(detail.reserved_leads.total_leads, detail.initial_traffic.total_users)
                                    }}
                                </div>
                                <div class="num">{{
                                        getPercent(detail.initial_communication.total_leads_in_progress, detail.reserved_leads.total_leads)
                                    }}
                                </div>
                                <div class="num">{{
                                        getPercent(detail.deal_metrics.leads_converted, detail.initial_communication.total_leads_in_progress)
                                    }}
                                </div>
                                <div class="num">{{
                                        getPercent(detail.deal_metrics.leads_converted, detail.initial_traffic.total_users)
                                    }}
                                </div>
                                <div class="num">{{
                                        getPercent(detail.deal_metrics.leads_converted, detail.initial_communication.total_leads_in_progress)
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="model-right">
                            <div class="item">
                                <div class="label">初始流量</div>
                                <div class="number">
                                    <span>{{ detail.initial_traffic.total_users }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">预留客资</div>
                                <div class="number">
                                    <span>{{ detail.reserved_leads.total_leads }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">初步沟通</div>
                                <div class="number">
                                    <span>{{ detail.initial_communication.total_leads_in_progress }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">产品成交</div>
                                <div class="number">
                                    <span>{{ detail.deal_metrics.leads_converted }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">签署合同</div>
                                <div class="number">
                                    <span>{{ detail.deal_metrics.contracts_signed }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="qa-box">
                    <div class="qa-head">
                        <img src="/assets/images/index/icon-msg.png">
                        <span>您有新的问卷完成待查看</span>
                    </div>
                    
                    <div class="qa-line"></div>
                    
                    <div class="qa-item" v-for="item in qaList" :key="item.member_qa_id" @click="activeMiniCode(item)">
                        
                        <div class="qa-title">
                            
                            <div class="qa-title-text">{{ item.title }}</div>
                            <img src="/assets/images/index/icon-6.png">
                        
                        </div>
                        
                        <div class="qa-info">
                            
                            <div class="info">
                                <div class="avatar">
                                    <img :src="item.ast_member.avatar">
                                </div>
                                <div class="name">{{ item.ast_member.name }}</div>
                            </div>
                            
                            <div class="qa-time">{{ formatTime(item.submit_at) }}</div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <MemberDetail ref="memberDetail"/>
    </div>
</template>

<script>
import Vue from 'vue';
import auth from "../auth";
import api from "@/repo/api";
import moment from 'moment';
import MemberDetail from '@/views/AST/Q&A/Com/MemberDetail.vue';
import AtMenuIcon from "@/components/AtMenuIcon.vue";

export default {
    components: {
        AtMenuIcon,
        MemberDetail
    },
    data() {
        return {
            detail: {
                deal_metrics: {},
                initial_communication: {},
                initial_traffic: {},
                order: {},
                reserved_leads: {},
                service_record: {},
            },
            items: [],
            qaList: [],
            app: {},
            info: {},
            astMember: {},
            currentMenu: "",
        }
    },
    mounted() {
        this.getAppStatus();
    },
    methods: {
        toggleMenu(hide) {
            this.$toggleMenu(hide);
        },
        getPercent(num, total) {
            if (total == 0) return '0%';
            return (num / total * 100).toFixed(1) + '%';
        },
        activeMiniCode(item) {
            console.log(item);
            this.$refs.memberDetail.getDetail(item.id, item.am_id);
        },
        formatTime(time) {
            return moment(time).format('yyyy-MM-DD HH:mm')
        },
        getqaList() {
            api.get('/ast-qa/last-member-qas', {}, res => {
                if (res.code == 0) {
                    // 只显示最新的4条
                    this.qaList = res.data.slice(0, 4);
                }
            })
        },
        fetchDetail() {
            api.get('/ast-data/real-time-data', {}, res => {
                if (res.code == 0) {
                    this.detail = res.data;
                }
            })
        },
        getAppStatus() {
            
            api.get('/ast-app/status', (data) => {
                
                if ((!data.data) || (!data.data.status) && (this.mode !== 'reg')) {
                    
                    this.$router.push('/login')
                    
                    return
                }
                
                auth.appLength(data.data.app_num)
                
                if (!data.data.register_finished && this.$route.path !== '/ast/pay/apply' && (this.mode !== 'reg')) {
                    
                    if (data.data.id !== 134) {
                        window.location.href = '/ast/reg';
                        return;
                    }
                    
                }
                
                let app = data.data
                
                app.roles = [app.master_type]
                
                if (data.data.is_owner) app.roles.push('owner')
                
                this.app = app
                this.ready = true
                
                if (app.status && app.payment.currency == 'CNY') {
                    app.payment.symbol = null;
                }
                
                Vue.prototype.$app = app;
                
                this.astMember = data.data.ast_member;
                
                auth.appId(app.id);
                
                auth.check((res) => {
                    this.info = res ? auth.userInfo() : false;
                })
                this.fetchDetail();
                this.getqaList();
                this.items = this.navs();
            })
        },
        navs() {
            
            return [
                {
                    'name': '小程序设置',
                    'icons': {
                        'normal': '/assets/icons/xcx-2.png',
                        'highlight': '/assets/icons/xcx-1.png',
                    },
                    'children': [
                        {
                            'name': '基础设置',
                            'route': '/ast/xcx/base',
                        },
                        {
                            'name': '功能设置',
                            'route': '/ast/xcx/item',
                        },
                        {
                            'name': "美学工具",
                            'children': [
                                {
                                    'name': '口红试色',
                                    'route': '/ast/config/tools/lipstick',
                                    'hide': (!this.app.modules.mx_lipstick),
                                },
                                {
                                    'name': '服装试色',
                                    'route': '/ast/config/tools/cloth',
                                    'hide': (!this.app.modules.mx_cloth),
                                },
                                {
                                    'name': '色彩诊断',
                                    'route': '/ast/config/tools/color',
                                    'hide': (!this.app.modules.mx_color),
                                }
                            ],
                        },
                        {
                            'name': "客户档案",
                            'children': [
                                {
                                    'name': '形象定位',
                                    'route': '/ast/config/member-profile/image-position',
                                },
                                {
                                    'name': '身体数据',
                                    'route': '/ast/config/member-profile/body-attribute',
                                }
                            ],
                        },
                        {
                            'name': '推送设置',
                            'route': '/ast/xcx/push',
                            'roles': ['manager'],
                        },
                        {
                            'name': '用量查询',
                            'route': '/ast/xcx/balance',
                        },
                        {
                            'name': '托管设置',
                            'route': '/ast/xcx/trusteeship',
                            'roles': ['manager'],
                        },
                        {
                            'name': 'API接口',
                            'hide': (!this.app.modules.yc_api),
                            'route': '/ast/xcx/open',
                            'roles': ['manager'],
                        },
                        {
                            'name': '管理员设置',
                            'route': '/ast/xcx/admin',
                        },
                        {
                            'name': '唯品会授权',
                            'route': '/ast/setting/vip',
                            'roles': ['manager'],
                        },
                        {
                            'name': '支付申请',
                            'route': '/ast/pay/apply',
                            'hide': (this.app.sub_mchid) || (this.app.model === 'person'),
                        }
                    ],
                },
                {
                    'name': '运营设置',
                    'icons': {
                        'normal': '/assets/icons/yy-2.png',
                        'highlight': '/assets/icons/yy-1.png',
                    },
                    'children': [
                        {
                            'name': '开通在线视频',
                            'route': '/ast/serve/video/open',
                            'hide': (this.$app.modules.course_video)
                        },
                        {
                            'name': '视频素材管理',
                            'route': '/ast/serve/video',
                            'hide': (!this.$app.modules.course_video)
                        },
                        {
                            'name': '会员类型设置',
                            'route': '/ast/serve/level'
                        },
                        {
                            'name': '服务介绍设置',
                            'route': '/ast/serve/ser'
                        },
                        {
                            'name': '课程介绍设置',
                            'route': '/ast/serve/cla'
                        },
                        {
                            'name': '活动介绍设置',
                            'route': '/ast/serve/act'
                        },
                        {
                            'name': '服务类型设置',
                            'route': '/ast/serve/type',
                        },
                        {
                            'name': '案例分享设置',
                            'route': '/ast/cases',
                        },
                        {
                            'name': '推广短链设置',
                            'route': '/ast/promotion/short-link',
                        },
                        {
                            'name': '问卷调查设置',
                            'route': '/ast/qas',
                        },
                        {
                            'name': '签署合同设置',
                            'route': '/ast/contract',
                            'hide': (!this.$app.modules.member_contract),
                        },
                        {
                            'name': '预约项目设置',
                            'children': [
                                {
                                    'name': '预约项目列表',
                                    'route': '/ast/project/list',
                                },
                                {
                                    'name': '项目老师列表',
                                    'route': '/ast/teacher/list',
                                },
                            ],
                        }
                    ],
                },
                {
                    'name': '会员列表',
                    'icons': {
                        'normal': '/assets/icons/hy-2.png',
                        'highlight': '/assets/icons/hy-1.png',
                    },
                    'children': [
                        {
                            'name': '会员列表',
                            'route': '/ast/members',
                        },
                        {
                            'name': '报名列表',
                            'route': '/ast/members/applies',
                        },
                        {
                            'name': '形象诊断书',
                            'route': '/ast/members/reports',
                        },
                        {
                            'name': '推荐列表',
                            'route': '/ast/shop/recommend',
                        }
                    ],
                },
                {
                    'name': '纸质报告',
                    'icons': {
                        'normal': '/assets/icons/zzbg-1.png',
                        'highlight': '/assets/icons/zzbg-1.png',
                    },
                    'children': [
                        {
                            'name': '机构基础信息',
                            'route': '/ast/paper/basic',
                        },
                        {
                            'name': '实体报告订单',
                            'route': '/ast/paper/orders',
                        },
                        {
                            'name': '报告兑换码',
                            'route': '/ast/paper/codes',
                        }
                    ]
                },
                {
                    'name': '服饰搭配',
                    'icons': {
                        'normal': '/assets/icons/dp-2.png',
                        'highlight': '/assets/icons/dp-1.png',
                    },
                    'children': [
                        {
                            'name': '自营店铺',
                            'route': '/ast/shop',
                            'hide': (!this.app.open_store),
                        },
                        {
                            'name': '搭配列表',
                            'children': [
                                {
                                    'name': '展示中',
                                    'route': `/ast/shop/scheme/show`,
                                },
                                {
                                    'name': '下架中',
                                    'route': `/ast/shop/scheme/hide`,
                                },
                                {
                                    'name': '回收站',
                                    'route': `/ast/shop/scheme/delete`,
                                }
                            ]
                        },
                        {
                            'name': '开始搭配',
                            'route': `/ast/decks`,
                        },
                        {
                            'name': '电商选品',
                            'route': '/ast/goods',
                        },
                        {
                            'name': '电商自选库',
                            'route': '/ast/goods/my',
                        },
                        {
                            'name': '自营单品',
                            'route': '/ast/shop/goods',
                            'hide': (!this.app.open_store),
                        },
                        {
                            'name': '商品上传',
                            'route': '/ast/shop/goods/review',
                            'hide': (this.app.open_store !== 1)
                        },
                        {
                            'name': '数据同步',
                            'route': '/ast/shop/goods/sync',
                            'hide': (this.app.open_store !== 1)
                        },
                        // {
                        //     'name': '展品列表',
                        //     'route': '/ast/shop/exhibits',
                        // },
                    ],
                },
                {
                    'name': '收银台',
                    'hide': (!this.app.modules.cashier) || (this.app.model === 'person'),
                    'children': [
                        {
                            'name': '收银订单',
                            'route': '/ast/shop/cashier',
                            'roles': ['manager'],
                        },
                        {
                            'name': '记账列表',
                            'route': '/ast/shop/bill',
                            'roles': ['manager'],
                        },
                        {
                            'name': "自动分销",
                            'route': '/ast/shop/share-setting',
                            'roles': ['manager'],
                        }
                    ],
                    'icons': {
                        'normal': '/assets/icons/cash.png',
                        'highlight': '/assets/icons/cash.png',
                    },
                },
            ];
        },
    }
}
</script>

<style lang="less" scoped>
.index-page {
    width: 100%;
    height: 100vh;
    background-image: url('https://static.ycsd.work/assets/images/bg.png');
    background-size: cover;
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.left-nav-container {
    width: 335px;
    background-color: white;
    padding-top: 64px;
    position: fixed;
    z-index: 101;
}

.page-left {
    width: 72px;
    height: 100%;
    border-right: 1px solid #FFFFFF;
    
    .menu-icon {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 24px;
        
        img {
            width: 24px;
            height: 24px;
        }
    }
}

.page-right {
    flex: 1;
    height: 100%;
    padding: 32px;
    box-sizing: border-box;
    cursor: context-menu;
}

.title {
    display: flex;
    
    img {
        width: 271px;
        height: 34px;
    }
}

.ant-row {
    display: flex !important;
}

.card-row {
    width: 1306px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 24px;
    
    .card-one {
        width: 258px;
        height: 176px;
        border-radius: 16px;
        backdrop-filter: blur(126px);
        box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
        background: linear-gradient(180deg, #FFFFFF 0%, #F7F4FF 100%);
        margin-right: 20px;
        padding: 0 16px;
        padding-top: 28px;
        position: relative;
        
        .card-icon {
            position: absolute;
            top: -6px;
            left: 0;
            
            img {
                width: 96px;
                height: 30px;
            }
        }
        
        .icon {
            width: 56px;
            height: 56px;
            box-shadow: 0px 4px 12px 0px rgba(163, 131, 244, 0.6);
            background: linear-gradient(180deg, #D3C5F7 0%, #A383F4 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            position: absolute;
            top: 28px;
            right: 16px;
            
            img {
                width: 24px;
                height: 24px;
            }
        }
        
        .icon2 {
            width: 20px;
            height: 20px;
            display: flex;
            position: absolute;
            bottom: 24px;
            right: 16px;
            
            img {
                width: 100%;
                height: 100%;
            }
        }
        
        .label {
            color: #333;
            font-size: 16px;
            font-weight: 600;
        }
        
        .number {
            width: fit-content;
            color: #333;
            font-size: 40px;
            font-weight: 600;
            line-height: 48px;
            margin-top: 8px;
            position: relative;
            
            .line {
                width: 100%;
                height: 6px;
                background: rgba(164, 132, 244, 1);
                filter: blur(8px);
                position: absolute;
                top: 80%;
            }
        }
        
        
        .total {
            color: #999;
            font-size: 16px;
            line-height: 22px;
            margin-top: 16px;
            
            span {
                &:nth-child(2) {
                    color: #333;
                    margin-left: 8px;
                }
            }
        }
    }
    
    .card-two {
        flex: 1;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        
        .card {
            width: 242px;
            height: 164px;
            background: rgba(255, 255, 255, 0.4);
            box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 16px;
            backdrop-filter: blur(126px);
            border: 1px solid #FFFFFF;
            position: relative;
            padding: 24px 16px;
            
            .icon {
                width: 56px;
                height: 56px;
                box-shadow: 0px 4px 12px 0px rgba(119, 134, 239, 0.6);
                background: linear-gradient(180deg, #B3BFF2 0%, #6E7EEF 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                position: absolute;
                top: 16px;
                right: 16px;
                
                img {
                    width: 24px;
                    height: 24px;
                }
            }
            
            .label {
                color: #333;
                font-size: 16px;
                font-weight: 600;
                
                span {
                    &:nth-child(2) {
                        color: #999999;
                        font-size: 12px;
                    }
                }
            }
            
            .number {
                color: rgba(51, 51, 51, 0.9);
                font-size: 32px;
                font-weight: 600;
                line-height: 40px;
                margin-top: 8px;
            }
            
            .total {
                color: #999;
                font-size: 16px;
                line-height: 22px;
                margin-top: 25px;
                
                span {
                    &:nth-child(2) {
                        color: #333;
                        margin-left: 8px;
                    }
                }
            }
        }
        
        .card1 {
            .icon {
                box-shadow: 0px 4px 12px 0px rgba(119, 134, 239, 0.6);
                background: linear-gradient(180deg, #B3BFF2 0%, #6E7EEF 100%);
            }
        }
        
        .card2 {
            .icon {
                box-shadow: 0px 4px 12px 0px rgba(224, 199, 80, 0.6);
                background: linear-gradient(180deg, #F1EB8B 0%, #E0C750 100%);
            }
        }
        
        .card3 {
            .icon {
                box-shadow: 0px 4px 12px 0px rgba(226, 136, 126, 0.6);
                background: linear-gradient(180deg, #F3C6B3 0%, #E2887E 100%);
            }
        }
        
        .card4 {
            .icon {
                box-shadow: 0px 4px 12px 0px rgba(105, 149, 239, 0.6);
                background: linear-gradient(180deg, #B0C9F2 0%, #6995EF 100%);
            }
        }
    }
}

.model-box {
    width: 1306px;
    margin-top: 32px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    
    .model-content {
        width: 1038px;
        height: 442px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        
        .title {
            width: 250px;
            height: 34px;
        }
        
        .model {
            width: 100%;
            height: 384px;
            background: rgba(255, 255, 255, 0.6);
            box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 16px;
            border: 1px solid #FFFFFF;
            padding: 24px;
            box-sizing: border-box;
            margin-top: 24px;
            backdrop-filter: blur(32px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            
            .icon {
                position: absolute;
                top: -6px;
                left: 0;
                
                img {
                    width: 96px;
                    height: 30px;
                }
            }
            
            .model-left {
                flex: 1;
                height: 100%;
                
                .add-num {
                    width: 348px;
                    height: 44px;
                    background: #F7F7F7;
                    border-radius: 4px;
                    margin: 0 auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    
                    span {
                        &:nth-child(1) {
                            color: #333333;
                            font-size: 14px;
                        }
                        
                        &:nth-child(2) {
                            color: #999999;
                            font-size: 14px;
                            margin: 0 8px;
                        }
                        
                        &:nth-child(3) {
                            color: #01BCD5;
                            font-size: 20px;
                        }
                        
                        &:nth-child(4) {
                            color: #01BCD5;
                            font-size: 14px;
                            margin-left: 8px;
                        }
                    }
                }
                
                .trapezoid-box {
                    margin: 24px auto 0;
                    width: 549px;
                    height: 264px;
                    position: relative;
                    
                    img {
                        width: 100%;
                        height: 100%;
                    }
                    
                    .num {
                        color: #000;
                        font-size: 14px;
                        position: absolute;
                        
                        &:nth-child(2) {
                            top: 39px;
                            left: 113px;
                        }
                        
                        &:nth-child(3) {
                            top: 84px;
                            left: 58px;
                        }
                        
                        &:nth-child(4) {
                            top: 132px;
                            left: 8px;
                        }
                        
                        &:nth-child(5) {
                            top: 87px;
                            right: 8px;
                        }
                        
                        &:nth-child(6) {
                            top: 104px;
                            right: 60px;
                        }
                    }
                }
            }
            
            .model-right {
                width: 328px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                
                .item {
                    width: 100%;
                    height: 56px;
                    background: #F7F7F7;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 16px;
                    
                    &:nth-last-child(1) {
                        background: #F4FBFD;
                    }
                    
                    .label {
                        color: #333;
                        font-size: 16px;
                    }
                    
                    .number {
                        color: #333;
                        font-weight: 500;
                        
                        span {
                            &:nth-child(1) {
                                font-size: 20px;
                            }
                            
                            &:nth-child(2) {
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
    }
    
    .qa-box {
        width: 242px;
        height: 442px;
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        border: 1px solid #FFFFFF;
        backdrop-filter: blur(24px);
        padding: 24px 16px;
        box-sizing: border-box;
        
        .qa-head {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            
            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            
            span {
                color: #333;
                font-size: 16px;
                font-weight: bold;
            }
        }
        
        .qa-line {
            width: 100%;
            height: 1px;
            background: #FFFFFF;
            margin-top: 16px;
        }
        
        .qa-item {
            width: 100%;
            height: 72px;
            background: #FAFAFA;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 16px;
            padding: 16px;
            box-sizing: border-box;
            cursor: pointer;
            
            .qa-title {
                width: 100%;
                display: flex;
                align-items: center;
                
                .qa-title-text {
                    flex: 1;
                    color: #333;
                    font-size: 14px;
                    font-weight: 500;
                    // 超出省略
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                
                img {
                    width: 16px;
                    height: 16px;
                }
            }
            
            .qa-info {
                width: 100%;
                display: flex;
                align-items: center;
                
                .info {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    
                    .avatar {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        margin-right: 4px;
                        background: #999;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        
                        img {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                        }
                    }
                    
                    .name {
                        width: 46px;
                        color: #333;
                        font-size: 12px;
                        // 超出省略
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                
                .qa-time {
                    color: #999;
                    font-size: 12px;
                }
            }
        }
    }
}

@media screen and (min-width: 1600px) {
    .index-page {
        zoom: 1.12;
    }
}
</style>